export default __webpack_public_path__ + "static/media/WUSD.deaf8ab8.svg";